import React from 'react';
import ReactDOM from 'react-dom/client';
import Admin from './Admin';
import ExcelUpload from './ExcelUpload';
import './index.css';
import Navigator from './Navigator';
import reportWebVitals from './reportWebVitals';
import { LspProvider } from './store/LspContext';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <LspProvider>
      <Navigator />
    </LspProvider>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
